import getId from '../../quote-editor/utils/get-id';
import createUiAction, { markUiAction } from '../../utils/create-ui-action';

export const remove = createUiAction('flash-messages/remove', id => ({ id }));

export const dismiss = id => dispatch => {
  dispatch(
    markUiAction({
      type: dismiss.toString(),
      payload: { id },
    }),
  );
  setTimeout(() => dispatch(remove(id)), 5 * 1000); // Leave some time for fade-out animations
};
dismiss.toString = () => 'flash-messages/dismiss';

export const flash =
  (message, color = 'success', timeout = 5, hidden = false) =>
  dispatch => {
    const id = getId();
    dispatch(
      markUiAction({
        type: flash.toString(),
        payload: { id, message, color, timeout, hidden },
      }),
    );

    if (timeout > 0) {
      setTimeout(() => dispatch(dismiss(id)), timeout * 1000);
    }
    return dispatch.bind(null, dismiss(id));
  };
flash.toString = () => 'flash-messages/flash';
